export default __webpack_public_path__ + "static/media/gallery-6-4.f937ae7e.webp";